// Metrics.tsx — the default dashboard page.
//
// The GPU performance dashboard itself (1m metric cards + history chart)
// lives in the inference web tree as GpuPerformancePanel and is shared
// verbatim with inference's Stats page. Here we just wire it to thirdeye's
// endpoints: the live summary comes from the inference-stats proxy
// (/api/inference/stats) and the history series from thirdeye's own
// 30s-cadence GPU metrics store (/api/gpu/history).
import React, { useMemo } from 'react';
import { GpuPerformancePanel } from '@inference/components/GpuPerformancePanel';
import type { GpuMetricsSource } from '@inference/components/GpuPerformancePanel';

import { metricsApi, inferenceApi } from '../api';

export const Metrics: React.FC = () => {
  // Stable adapter so the panel's poll loop isn't restarted each render.
  const source = useMemo<GpuMetricsSource>(() => ({
    stats: async () => {
      const stats = await inferenceApi.stats();
      return stats?.gpu ?? null;
    },
    history: (hours) => metricsApi.getGpuHistory(hours),
  }), []);

  return (
    <div>
      <h2 className="mb-4">Metrics</h2>
      <GpuPerformancePanel source={source} />
    </div>
  );
};

export default Metrics;
